class WishlistToast {
  constructor() {
    this.el = null;
    this.timer = null;
    this._build();
    document.addEventListener('wishlist:toast', e => this.show(e.detail));
  }

  _build() {
    this.el = document.createElement('div');
    this.el.className = 'wishlist-toast';
    this.el.setAttribute('role', 'status');
    this.el.setAttribute('aria-live', 'polite');
    document.body.appendChild(this.el);
  }

  show({ added, moved, product }) {
    clearTimeout(this.timer);
    const i18n = window.wishlistI18n || {};
    const url = (window.wishlistConfig || {}).wishlistPageUrl || '/pages/wishlist';

    if (moved) {
      this.el.innerHTML = `
        <span class="wishlist-toast__icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.4626 3.99415C16.7809 2.34923 14.4404 3.01211 13.0344 4.06801C12.4578 4.50096 12.1696 4.71743 12 4.71743C11.8304 4.71743 11.5422 4.50096 10.9656 4.06801C9.55962 3.01211 7.21909 2.34923 4.53744 3.99415C1.01807 6.15294 0.22172 13.2749 8.33953 19.2834C9.88572 20.4278 10.6588 21 12 21C13.3412 21 14.1143 20.4278 15.6605 19.2834C23.7783 13.2749 22.9819 6.15294 19.4626 3.99415Z"/>
          </svg>
        </span>
        <span class="wishlist-toast__text">
          ${i18n.moved_to || 'Moved to Wishlist'} &middot;
          <a href="${url}" class="wishlist-toast__link no-underline">${i18n.view || 'View'} &rarr;</a>
        </span>
      `;
      requestAnimationFrame(() => { this.el.classList.add('is-visible'); });
      this.timer = setTimeout(() => { this.el.classList.remove('is-visible'); }, 3200);
      return;
    }

    if (added) {
      this.el.innerHTML = `
        <span class="wishlist-toast__icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.4626 3.99415C16.7809 2.34923 14.4404 3.01211 13.0344 4.06801C12.4578 4.50096 12.1696 4.71743 12 4.71743C11.8304 4.71743 11.5422 4.50096 10.9656 4.06801C9.55962 3.01211 7.21909 2.34923 4.53744 3.99415C1.01807 6.15294 0.22172 13.2749 8.33953 19.2834C9.88572 20.4278 10.6588 21 12 21C13.3412 21 14.1143 20.4278 15.6605 19.2834C23.7783 13.2749 22.9819 6.15294 19.4626 3.99415Z"/>
          </svg>
        </span>
        <span class="wishlist-toast__text">
          ${i18n.added || 'Added to wishlist'} &middot; <a href="${url}" class="wishlist-toast__link no-underline">${i18n.view || 'View'} &rarr;</a>
        </span>
      `;
    } else {
      this.el.innerHTML = `
        <span class="wishlist-toast__icon" style="opacity:0.45">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.4626 3.99415C16.7809 2.34923 14.4404 3.01211 13.0344 4.06801C12.4578 4.50096 12.1696 4.71743 12 4.71743C11.8304 4.71743 11.5422 4.50096 10.9656 4.06801C9.55962 3.01211 7.21909 2.34923 4.53744 3.99415C1.01807 6.15294 0.22172 13.2749 8.33953 19.2834C9.88572 20.4278 10.6588 21 12 21C13.3412 21 14.1143 20.4278 15.6605 19.2834C23.7783 13.2749 22.9819 6.15294 19.4626 3.99415Z"/>
          </svg>
        </span>
        <span class="wishlist-toast__text">${i18n.removed || 'Removed from wishlist'}</span>
      `;
    }

    requestAnimationFrame(() => {
      this.el.classList.add('is-visible');
    });

    this.timer = setTimeout(() => {
      this.el.classList.remove('is-visible');
    }, 3200);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new WishlistToast();
});
